<template>
  <div class="notfound">
    <h1>404</h1>
    <p>页面不存在</p>
    <router-link to="/">返回首页</router-link>
  </div>
</template>

<style>
.notfound {
  text-align: center;
  margin-top: 100px;
}
</style>